// React
import React, { useState } from 'react';
import EditInformationComponent from '../edit-information/EditInformationComponent';
// import TextButtonComponent from 'shared/components/text-button/TextButtonComponent'

//i18
import { withTranslation } from 'react-i18next';

// Moment
import * as moment from 'moment';
// Locale
import 'moment/locale/en-au';
import 'moment/locale/es';

// Styles
import './AccountInformationComponent.styles.css';

// React device detect
import { isMobile } from 'react-device-detect';
import EditInformationModalComponent from '../edit-information-modal/EditInformationModalComponent';
import EditEmailPhoneModalComponent from '../edit-email-phone-modal/EditEmailPhoneModalComponent';

function AccountInformationComponent ( props ) {

    const [editField, setEditField] = useState(null);
    const [editValue, setEditValue] = useState(null);
    const [openEditModal, setOpenEditModal]= useState(false);
    const [openEditEmailPhoneModal, setOpenEditEmailPhoneModal]= useState(false);

    const handleCloseEditModal=()=>{
        setEditField(null);
        setEditValue(null);
        setOpenEditModal(false);
    }

    const handleCloseEmailPhoneModal=()=>{
        setEditField(null);
        setEditValue(null);
        setOpenEditEmailPhoneModal(false);
    }

    return (

        <div className="edit-content">

            <div className="edit-content__title baloa-subtitle-2">
                    { props.t('settings.info.title') }
            </div>
            <div className='edit-content__content'>
                {/* edit name */}
                {/* <div className="edit-content__info">
                    { !isMobile
                        ?
                        <React.Fragment>
                            <span className="edit-content__info__content baloa-names"> {props.t('settings.info.name')} </span>                                           
                            <span className="edit-content__text baloa-names">{ props.user.first_name }</span>
                        </React.Fragment>
                        :
                        <div className='edit-content__mobile-info'>
                            <span className="edit-content__info__content baloa-names"> {props.t('settings.info.name')} </span>                                           
                            <span className="edit-content__text baloa-names">{ props.user.first_name }</span>
                        </div>
                    }
                    
                    <div 
                        className="edit-content__button"
                        onClick={() => {
                            setEdit(props.t('settings.info.name'));
                            setEditValue(props.user.first_name);
                            props.data_edit(0);
                        }}
                    >
                        <span className="edit-content__button__text baloa-hyperlink-2">{props.t('settings.btnEdit')}</span>
                    </div>                   
                </div> */}
                {/* edit lastname */}
                {/* <div className="edit-content__info">
                    { !isMobile
                        ?
                        <React.Fragment>
                            <span className="edit-content__info__content baloa-names"> {props.t('settings.info.lastName')} </span>                                           
                            <span className="edit-content__text baloa-names">{ props.user.last_name }</span>
                        </React.Fragment>
                        :
                        <div className='edit-content__mobile-info'>
                            <span className="edit-content__info__content baloa-names"> {props.t('settings.info.lastName')} </span>                                           
                            <span className="edit-content__text baloa-names">{ props.user.last_name }</span>
                        </div>
                    }
                    
                    <div 
                        className="edit-content__button"
                        onClick={() => {
                            setEdit(props.t('settings.info.lastName'));
                            setEditValue(props.user.last_name);
                            props.data_edit(0);
                        }}
                    >
                        <span className="edit-content__button__text baloa-hyperlink-2">{props.t('settings.btnEdit')}</span>
                    </div>
                </div> */}

                {/* edit fullname */}
                <div className="edit-content__info">
                    <div className='edit-content__info-data'>
                        <div className="baloa-normal-medium"> {props.t('settings.info.name')} </div>                                           
                        <div className="baloa-names">{ `${props.user.first_name} ${props.user.last_name}` }</div>
                    </div>
                    <span className='hubicon-edit1'
                        onClick={() => {
                            setEditField('name');
                            setEditValue({first_name: props.user.first_name, last_name: props.user.last_name});
                            setOpenEditModal(true);
                        }}
                    />    
                </div>

                {/* edit username */}
                <div className="edit-content__info">
                    { /* !isMobile
                        ?
                        <React.Fragment>
                            <span className="edit-content__info__content baloa-names"> {props.t('settings.info.username')} </span>                                           
                            <span className="edit-content__text baloa-names">@{ props.user.username }</span>
                        </React.Fragment>
                        :
                        <div className='edit-content__mobile-info'>
                            <span className="edit-content__info__content baloa-names"> {props.t('settings.info.username')} </span>                                           
                            <span className="edit-content__text baloa-names">@{ props.user.username }</span>
                        </div> */
                    }
                    
                    {/* <div 
                        className="edit-content__button"
                        onClick={() => {
                            setEdit(props.t('settings.info.username'));
                            setEditValue(props.user.username);
                            props.data_edit(0);
                        }}
                    >
                        <span className="edit-content__button__text baloa-hyperlink-2">{props.t('settings.btnEdit')}</span>
                    </div> */}
                    <div className='edit-content__info-data'>
                        <div className="baloa-normal-medium"> {props.t('settings.info.username')} </div>                                           
                        <div className="baloa-names">{ props.user.username }</div>
                    </div>
                    <span className='hubicon-edit1'
                        onClick={() => {
                            setEditField('username');
                            setEditValue(props.user.username);
                            setOpenEditModal(true);
                        }}
                    /> 
                </div>

                {/* edit birthday */}
                <div className="edit-content__info">
                    <div className='edit-content__info-data'>
                        <div className="baloa-normal-medium"> {props.t('settings.info.birthday')} </div>                                           
                        <div className="baloa-names">{moment(props.user.birthday).format('LL') }</div>
                    </div>
                    <span className='hubicon-edit1'
                        onClick={() => {
                            setEditField('birthday');
                            setEditValue(props.user.birthday);
                            setOpenEditModal(true);
                        }}
                    />    
                </div>

                {/* edit email */}
                <div className="edit-content__info">
                    { /* !isMobile
                        ?
                        <React.Fragment>
                            <span className="edit-content__info__content baloa-names"> {props.t('settings.info.email')} </span>                                           
                            <span className="edit-content__text baloa-names">{ props.user.email ? props.user.email : props.t('settings.textAlert') }</span>
                        </React.Fragment>
                        :
                        <div className='edit-content__mobile-info'>
                            <span className="edit-content__info__content baloa-names email"> {props.t('settings.info.email')} </span>                                           
                            <span className="edit-content__text baloa-names">{ props.user.email ? props.user.email : props.t('settings.textAlert') }</span>
                        </div> */

                    }
                    
                    {/* <div 
                        className="edit-content__button"
                        onClick={() => {
                            setEdit(props.t('settings.info.email'));
                            setEditValue(props.user.email);
                            props.data_edit(0);
                        }}
                    >
                        <span className="edit-content__button__text baloa-hyperlink-2">
                            { props.user.email ? props.t('settings.btnEdit') : props.t('settings.btnComplete') }
                        </span>
                    </div> */}

                    <div className='edit-content__info-data'>
                        <div className="baloa-normal-medium"> {props.t('settings.info.email')} </div>                                           
                        <div className="baloa-names">{ props.user.email ? props.user.email : props.t('settings.textAlert') }</div>
                    </div>
                    <span className='hubicon-edit1'
                        onClick={() => {
                            setEditField('email');
                            setEditValue(props.user.email);
                            props.handleOnOpenEditEmailPhoneModal(true);
                        }}
                    /> 
                </div>

                {/* edit phone */}
                <div className="edit-content__info">
                    { /* !isMobile
                        ?
                        <React.Fragment>
                            <span className="edit-content__info__content baloa-names"> {props.t('settings.info.mobile')} </span>                                           
                            <span className="edit-content__text baloa-names">{ props.user.phone ? props.user.phone : props.t('settings.textAlert') }</span>
                        </React.Fragment>
                        :
                        <div className='edit-content__mobile-info'>
                            <span className="edit-content__info__content baloa-names"> {props.t('settings.info.mobile')} </span>                                           
                            <span className="edit-content__text baloa-names">{ props.user.phone ? props.user.phone : props.t('settings.textAlert') }</span>
                        </div> */
                    }
                    
                    {/* <div 
                        className="edit-content__button"
                        onClick={() => {
                            setEdit(props.t('settings.info.mobile'));
                            setEditValue(props.user.phone);
                            props.data_edit(0);
                        }}
                    >
                        <span className="edit-content__button__text baloa-hyperlink-2">
                            { props.user.phone ? props.t('settings.btnEdit') : props.t('settings.btnComplete') }
                        </span>
                    </div> */}

                    <div className='edit-content__info-data'>
                        <div className="baloa-normal-medium"> {props.t('settings.info.phone')} </div>                                           
                        <div className="baloa-names">{ props.user.phone ? `+${props.user.phone}` : props.t('settings.textAlert') }</div>
                    </div>
                    <span className='hubicon-edit1'
                        onClick={() => {
                            setEditField('phone');
                            setEditValue(props.user.phone);
                            props.handleOnOpenEditEmailPhoneModal(true);
                        }}
                    /> 
                </div>
            </div>
            <EditInformationModalComponent
                isOpen={ openEditModal }
                onClose={()=>{ handleCloseEditModal() }}
                field={editField}
                value={editValue}
                onNewData={ ( detail_data,new_data ) => {props.onNewData( detail_data,new_data ); handleCloseEditModal();} }
                errors = { props.errors }
                resetError={props.onResetError}
            />
            <EditEmailPhoneModalComponent
                isOpen={ props.edit_email_phone_modal_open }
                onClose={()=>{ props.handleOnCloseEditEmailPhoneModal() }}
                field={editField}
                value={editValue}
                user_id={ props.user_id }
                errors = { props.errors }
                resetError={props.onResetError}
                onEditEmailPhone={ ( detail_data,new_data ) => {props.onEditEmailPhone( detail_data,new_data ); } }
                constantsSingup={props.constantsSingup}
                send_phone_otp={props.send_phone_otp}
                phoneOtpSendAction={props.phoneOtpSendAction}
                send_email_otp={props.send_email_otp}
                emailOtpSendAction={props.emailOtpSendAction}
            />
        </div>
        
    )
}

export default withTranslation("profile")(AccountInformationComponent);